__turbopack_context__.v({
  "actions": "tdygcG_actions",
  "banner": "tdygcG_banner",
  "checkbox": "tdygcG_checkbox",
  "content": "tdygcG_content",
  "description": "tdygcG_description",
  "fadeIn": "tdygcG_fadeIn",
  "learnMore": "tdygcG_learnMore",
  "link": "tdygcG_link",
  "option": "tdygcG_option",
  "optionDesc": "tdygcG_optionDesc",
  "optionHeader": "tdygcG_optionHeader",
  "optionTitle": "tdygcG_optionTitle",
  "options": "tdygcG_options",
  "overlay": "tdygcG_overlay",
  "slideIn": "tdygcG_slideIn",
  "slideUp": "tdygcG_slideUp",
  "title": "tdygcG_title",
});
